import { I18n } from '@boschebike/ebds-js';
import { useContext } from 'react';
import { termsOfUseRoutes } from '../../config/router';
import { InternalNavigationLink, Page } from '../../components';
import { DxfIntegrationContext } from '../../context/dxfIntegrationContext';
import { PlatformContext } from '../../context/platformContext';
import { interpolateContentToJSX } from '../../helpers';
import { useContent } from '../../hooks/use-content';

export const TermsOfUseForDealersSubPortal = () => {
  const content: I18n = useContent();
  const platformContext = useContext(PlatformContext);
  const dxfIntegrationContext = useContext(DxfIntegrationContext);

  const jsxContent: JSX.Element[] = interpolateContentToJSX(content.t('portal.termsOfUse.dealersSubPortal'), [
    {
      selector: 'default-link-dealers',
      element: InternalNavigationLink,
      elementProps: {
        href: dxfIntegrationContext.getInternalNavigationLink('dealers'),
        text: content.t('portal.termsOfUse.linkText'),
      },
    },
  ]);

  return (
    <Page
      links={termsOfUseRoutes(content, { isDPASupported: dxfIntegrationContext.isDPASupported, isDXF: platformContext.isDXF })}
      enforcedTabId='300'
    >
      {...jsxContent}
    </Page>
  );
};
